<template>
<div v-if="status.pending || status.loggingIn">
	<v-dialog
	v-model="show"
	width="300px"
	hide-overlay
	>
		<v-card
			color="primary"
			dark
		>
			<v-card-text>
			<template v-if="status.pending">
				Registering …
			</template>
			<template v-else-if="status.loggingIn">
				Logging in …
			</template>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
			</v-card-text>
		</v-card>

	</v-dialog>
</div>
<div v-else-if="!user">
	<v-dialog v-model="show" persistent width="800px">
		<v-card>
			<v-card-title class="headline">
				Register as a new user
			</v-card-title>
			<v-container>
				<v-form ref="registration" v-model="formValid">
				<v-layout row wrap>
					<v-flex xs12>
						<v-alert
						:value="status.error"
						type="error"
						icon="warning"
						>
						{{status.error}}
						</v-alert>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							prepend-icon="fa-user"
							placeholder="User handle"
							hint="Enter a unique username"
							v-model="handle"
							:rules="handleRules"
							:error-messages="handleAvailable"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							prepend-icon="fa-envelope"
							placeholder="Email address – optional"
							hint="Your email address will not be shared with anyone"
							type="email"
							v-model="email"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							:append-icon="showPwd ? 'fa-eye-slash' : 'fa-eye'"
							@click:append="showPwd = !showPwd"
							:type="showPwd ? 'text' : 'password'"
							:hint="showPwd ? 'This is your password' : 'Enter a password'"
							prepend-icon="fa-key"
							placeholder="Password"
							v-model="password"
							:rules="passwordRules"
							required
						></v-text-field>
					</v-flex>
				</v-layout>
				</v-form>
			</v-container>
				<v-card-actions>
					<v-btn flat @click="dismiss">Cancel</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat color="primary" @click="submit" :disabled="!formValid">Register</v-btn>
				</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vuex from 'vuex'
import api from '../../assets/js/api-instance'

export default {
	name: "FollowRegistration",
	
	props: ["show"],

	data () {
		return {
			handle: "",
			email: "",
			password: "",
			showPwd: false,
			formValid: false,
			handleAvailable: [],
			handleRules: [
				v => v && v.length > 0 || "Handle cannot be empty"
			],
			passwordRules: [
				v => v && v.length > 0 || "Password cannot be empty"
			],
			status: {}
		};
	},
	
	watch: {
		async handle (value) {
			const res = await api.checkHandleExists(value);
			console.log("HANDLE EXISTS", res);
			this.handleAvailable = res
				? [ "This handle is already taken" ]
				: [];
		}
	},
	
	computed: {
		...Vuex.mapState(["user"])
	},

	methods: {
		
		async dismiss () {
			this.$refs.registration.reset();
			this.handleAvailable = [];
			this.status = {};
			this.$emit("hide");
		},

		async submit () {
			try {
				this.status = {pending: true};
				const credentials = {
					handle: this.handle,
					password: this.password,
					metadata: {
						email: this.email
					}
				};
				const cu = await api.createUser(credentials);
				console.log("User created", cu);
				this.status = {loggingIn: true};
				const li = await api.login(credentials);
				console.log("Logged in", li);
				this.status = {loggedIn: true};
				
				await this.$store.dispatch('restore');
				//this.$emit("hide");
				this.dismiss();
			} catch (err) {
				console.log("Ee", err);
				if (err.unauthorised) {
					this.status = { error: "Bad login" };
				} else if (err.code == "network_error") {
					this.status = { error: "Network error" };
				} else if (err.code == "missing_required_data") {
					this.status = { error: "Missing required data" };
				} else {
					this.status = { error: "Unknown error" };
				}
			}
		}
	}
}
</script>
